<template>
  <div class="p-consumer-profile">
    <div
      class="p-consumer-profile__card"
    >
      <consumer-profile-card />
    </div>
    <div class="p-consumer-profile__card">
      <email-notifications-settings-card />
    </div>
    <div
      v-if="showDeleteAccountCard"
      class="p-consumer-profile__card"
    >
      <delete-account-card type="consumer" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ConsumerProfileCard from '@/app/components/consumer-profile/ConsumerProfileCard.vue';
import EmailNotificationsSettingsCard from '@/app/components/consumer-profile/EmailNotificationsSettingsCard.vue';
import DeleteAccountCard from '@/app/components/delete-account/DeleteAccountCard.vue';
import { CustomerType } from '@/app/services/DeleteAccountService';

export default {
  name: 'ConsumerProfile',
  components: {
    ConsumerProfileCard,
    EmailNotificationsSettingsCard,
    DeleteAccountCard
  },
  computed: {
    ...mapGetters('app', [
      'customerType'
    ]),
    showDeleteAccountCard() {
      return this.customerType === CustomerType.atih;
    }
  }
};
</script>

<style lang="scss" scoped>
.p-consumer-profile {
  height: 100%;
  padding: 24px;
  overflow: auto;

  &__card {
    margin: 0 auto 24px auto;
    max-width: 832px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
